import styled from 'styled-components'

export const OutlinedList = styled.div`
  border-radius: 5px;
  border: 1px solid ${props => props.theme.summary.grey};
  padding: 10px;
  margin: 5px;
  margin-top: 24px;
  max-height: 218px;
  overflow: auto;
`

export const OutlinedListTitle = styled.div`
  position: absolute;
  background-color: ${props => props.theme.white.light};
  margin-top: -20px;
  padding: 0 5px;
  font-size: smaller;
  color: ${props => props.theme.black.light};
`

export const AddURLButton = styled.span`
  cursor: pointer;
  color: inherit;
  &:hover {
    text-decoration: underline;
  }
`